import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { ProductDetail, ProductRow, ProductsService } from './products.service';

@Component({
  selector: 'app-product-details-dialog',
  standalone: true,
  imports: [CommonModule, RouterModule, MatDialogModule],
  styleUrls: ['./products.component.scss'],
  templateUrl: './product-details-dialog.component.html'
})
export class ProductDetailsDialogComponent implements OnInit, OnDestroy {
  detail?: ProductDetail;
  loading = true;
  error = '';
  private destroyed = new Subject<void>();

  fields: { key: keyof ProductRow; label: string }[] = [
    { key: 'description', label: 'Description' },
    { key: 'model', label: 'Model' },
    { key: 'product_code', label: 'Product code' },
    { key: 'serial', label: 'Serial' },
    { key: 'barcode', label: 'Barcode' },
    { key: 'package_id', label: 'Package ID' },
    { key: 'declared_quantity', label: 'Declared package quantity' },
    { key: 'return_status', label: 'Return status' },
    { key: 'carton_resolution', label: 'Carton resolution' }
  ];
  references: { key: keyof ProductRow; label: string }[] = [
    { key: 'po_number', label: 'PO' },
    { key: 'so_number', label: 'SO' },
    { key: 'asn_number', label: 'ASN' },
    { key: 'bol_number', label: 'BOL' },
    { key: 'trip_number', label: 'Trip number' }
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { row: ProductRow; theme: 'dark' | 'light' },
    private readonly service: ProductsService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = '';
    this.service
      .detail(this.data.row)
      .pipe(takeUntil(this.destroyed))
      .subscribe({
        next: d => {
          this.detail = d;
          this.loading = false;
        },
        error: e => {
          this.loading = false;
          this.error = e.error?.message || 'Details could not load.';
        }
      });
  }

  value(v: unknown): string {
    return v === null || v === undefined || v === '' ? '—' : String(v);
  }

  date(v: string | null): string {
    return v ? v.replace('T', ' ').slice(0, 16) : '—';
  }

  flag(v: boolean | null): string {
    return v === true ? 'Yes' : v === false ? 'No' : 'Unknown';
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
